var map = {
	"./action.svg": 205,
	"./adventure.svg": 206,
	"./advertorial.svg": 207,
	"./album.svg": 208,
	"./analysis.svg": 209,
	"./anchor.svg": 210,
	"./android-block.svg": 211,
	"./android-small.svg": 212,
	"./android.svg": 213,
	"./angle-down.svg": 214,
	"./angle-left.svg": 215,
	"./angle-right.svg": 216,
	"./angle-up.svg": 217,
	"./aquarius.svg": 218,
	"./arcade.svg": 219,
	"./aries.svg": 220,
	"./arrow-down.svg": 221,
	"./arrow-left.svg": 222,
	"./arrow-right.svg": 223,
	"./arrow-up.svg": 224,
	"./arrow.svg": 225,
	"./art-director.svg": 226,
	"./astrology.svg": 227,
	"./author-avator.svg": 228,
	"./author.svg": 229,
	"./authoranchor.svg": 230,
	"./authorwhite.svg": 231,
	"./automobile.svg": 232,
	"./backward.svg": 233,
	"./bookmark.svg": 234,
	"./books-vikatan.svg": 235,
	"./brandconnect.svg": 236,
	"./breaking-news.svg": 237,
	"./bullet-arrow.svg": 238,
	"./bundle.svg": 239,
	"./business.svg": 240,
	"./calendar.svg": 241,
	"./cancel.svg": 242,
	"./cancer.svg": 243,
	"./canvas.svg": 244,
	"./capricorn.svg": 245,
	"./cartoonist.svg": 246,
	"./cinema.svg": 247,
	"./clapboard.svg": 248,
	"./clipboard.svg": 249,
	"./close.svg": 250,
	"./comment.svg": 251,
	"./corona-updates-icon.svg": 252,
	"./creative-director.svg": 253,
	"./cricket.svg": 254,
	"./crime.svg": 255,
	"./data.svg": 256,
	"./designed.svg": 257,
	"./double-arrow.svg": 258,
	"./downarrow.svg": 259,
	"./download.svg": 260,
	"./edit.svg": 261,
	"./edited-by.svg": 262,
	"./email.svg": 263,
	"./environment.svg": 264,
	"./exclusivedeals.svg": 265,
	"./facebook-bg.svg": 266,
	"./facebook-icon.svg": 267,
	"./facebook.svg": 268,
	"./filter-icon.svg": 269,
	"./filter.svg": 270,
	"./food-stylist.svg": 271,
	"./forward.svg": 272,
	"./gallery.svg": 273,
	"./game-shop.svg": 274,
	"./gemini.svg": 275,
	"./group.svg": 276,
	"./gzhome.svg": 277,
	"./gzsports.svg": 278,
	"./gztrending.svg": 279,
	"./health.svg": 280,
	"./hexbackground.svg": 281,
	"./home.svg": 282,
	"./humoursatire-entertainment.svg": 283,
	"./icon-apple.svg": 284,
	"./icon-appstore.svg": 285,
	"./icon-audio-app-store.svg": 286,
	"./icon-audio-fb.svg": 287,
	"./icon-audio-instagram.svg": 288,
	"./icon-audio-next.svg": 289,
	"./icon-audio-play-store.svg": 290,
	"./icon-audio-previous.svg": 291,
	"./icon-audio-twitter.svg": 292,
	"./icon-audio-whatsapp.svg": 293,
	"./icon-copy.svg": 294,
	"./icon-episode.svg": 295,
	"./icon-facebook.svg": 296,
	"./icon-google-play.svg": 297,
	"./icon-headset.svg": 298,
	"./icon-home-plus.svg": 299,
	"./icon-login.svg": 300,
	"./icon-open-in-new.svg": 301,
	"./icon-pause.svg": 302,
	"./icon-play.svg": 303,
	"./icon-playstore.svg": 304,
	"./icon-premium.svg": 305,
	"./icon-share.svg": 306,
	"./icon-star.svg": 307,
	"./icon-timer.svg": 308,
	"./icon-twitter.svg": 309,
	"./icon-user.svg": 310,
	"./icon-video.svg": 311,
	"./icon-whatsapp.svg": 312,
	"./illustrator-t1.svg": 313,
	"./illustrator.svg": 314,
	"./infographer.svg": 315,
	"./instagram.svg": 316,
	"./interviews.svg": 317,
	"./ios-block.svg": 318,
	"./ios-small.svg": 319,
	"./ios.svg": 320,
	"./jokes.svg": 321,
	"./leo.svg": 322,
	"./libra.svg": 323,
	"./lifestyle.svg": 324,
	"./line-arrow-next.svg": 325,
	"./line-arrow-prev.svg": 326,
	"./linkedin.svg": 327,
	"./listicle.svg": 328,
	"./live-chat.svg": 329,
	"./liveupdate.svg": 330,
	"./log green.svg": 331,
	"./log grey.svg": 332,
	"./log white.svg": 333,
	"./logic.svg": 334,
	"./login-facebook.svg": 335,
	"./login-google.svg": 336,
	"./login.svg": 337,
	"./logout-mobile.svg": 338,
	"./logout.svg": 339,
	"./longform.svg": 340,
	"./magazines.svg": 341,
	"./mail.svg": 342,
	"./menu-search.svg": 343,
	"./microphone.svg": 344,
	"./minus.svg": 345,
	"./mobile-share.svg": 346,
	"./moderated.svg": 347,
	"./more-outline.svg": 348,
	"./my-vikatan-logo.svg": 349,
	"./mynews.svg": 350,
	"./myvikatanbadge.svg": 351,
	"./narrated.svg": 352,
	"./news.svg": 353,
	"./newsletter.svg": 354,
	"./newslettericon.svg": 355,
	"./olympic.svg": 356,
	"./online-news.svg": 357,
	"./pause.svg": 358,
	"./pdf.svg": 359,
	"./pen.svg": 360,
	"./personalise.svg": 361,
	"./phone.svg": 362,
	"./photo.svg": 363,
	"./photographer.svg": 364,
	"./photostory.svg": 365,
	"./pisces.svg": 366,
	"./play.svg": 367,
	"./plus.svg": 368,
	"./podcast.svg": 369,
	"./podcast_vikatan_menu.svg": 370,
	"./poems.svg": 371,
	"./politics.svg": 372,
	"./premium.svg": 373,
	"./producer.svg": 374,
	"./proofread.svg": 375,
	"./published-by.svg": 376,
	"./published.svg": 377,
	"./rain.svg": 378,
	"./rss.svg": 379,
	"./rupee.svg": 380,
	"./sagitarius.svg": 381,
	"./scorpio.svg": 382,
	"./script-writer.svg": 383,
	"./scripted.svg": 384,
	"./search.svg": 385,
	"./share-alt.svg": 386,
	"./share.svg": 387,
	"./sharechat.svg": 388,
	"./shortform.svg": 389,
	"./shortstories.svg": 390,
	"./shortvideo.svg": 391,
	"./slider-next.svg": 392,
	"./slider-prev.svg": 393,
	"./socialshare.svg": 394,
	"./sort.svg": 395,
	"./sound.svg": 396,
	"./speaker.svg": 397,
	"./speakeraudio.svg": 398,
	"./spiritual.svg": 399,
	"./sponsored.svg": 400,
	"./sports.svg": 401,
	"./star.svg": 402,
	"./stories.svg": 403,
	"./strategy.svg": 404,
	"./stylist.svg": 405,
	"./subscribe-vikatan.svg": 406,
	"./success-icon.svg": 407,
	"./tag.svg": 408,
	"./taurus.svg": 409,
	"./technology.svg": 410,
	"./text.svg": 411,
	"./textsms.svg": 412,
	"./thodargal.svg": 413,
	"./thump.svg": 414,
	"./tick.svg": 415,
	"./trending.svg": 416,
	"./twitter-icon.svg": 417,
	"./twitter.svg": 418,
	"./uparrow.svg": 419,
	"./update-black.svg": 420,
	"./user-square.svg": 421,
	"./user.svg": 422,
	"./v-plus-logo.svg": 423,
	"./video-editor.svg": 424,
	"./video-icon.svg": 425,
	"./video-play.svg": 426,
	"./video.svg": 427,
	"./videographer.svg": 428,
	"./vikatan-play-logo-red.svg": 429,
	"./vikatan-play.svg": 430,
	"./vikatan-tv.svg": 431,
	"./vikatan.svg": 432,
	"./vikatanconnect.svg": 433,
	"./vikatanplay.svg": 434,
	"./vikatanspl.svg": 435,
	"./vikatantv.svg": 436,
	"./virgo.svg": 437,
	"./whatsapp-icon.svg": 438,
	"./whatsapp-icon1.svg": 439,
	"./whatsapp.svg": 440,
	"./women-home.svg": 441,
	"./writtenarticles.svg": 442,
	"./writtenstory.svg": 443,
	"./youtube.svg": 444
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 204;